import * as actionsTypes from './actionsTypes';

export const actionMenuStickyChanged = (actionMenuSticky) => {
    return {
        type: actionsTypes.ACTION_MENU_STICKY,
        actionMenuSticky: actionMenuSticky
    }
}